import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: '/adfloordersagent',
      name: 'adfloordersagent',
      component: () =>
        import(/* webpackChunkName: "adfloordersagent" */ './components/AdfloOrdersAgent.vue'),
    },
  ],
  Module.ADFLO_ORDERS_AGENT
);
